import React from "react";
import { Navigate } from "react-router-dom";
function ClientAdminProtected({ access, children }) {
  const token = localStorage.getItem("isAdmin");
  return token === "true" ? (

    access === false ? (
      <Navigate to="/home" />
    ) : (
      children
    )
  ) : (
    <Navigate to="/home" />
  );
}

export default ClientAdminProtected;
